export default "__VITE_ASSET__CEVWUi59__"